import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class AtomsFormsSelectComponent extends Component {
  @action
  async validateProperty(changeset, property) {
    if (this.args.onBlur) {
      this.args.onBlur(changeset);
    }
    return changeset?.validate(property);
  }

  @action
  handleChange(changeset, id, e) {
    if (this.args.handleChange) {
      this.args.handleChange(...arguments);
      return;
    }
    changeset.set(id, e.target.value);
  }
}
